/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The field ids used in the Segment builder form.
 * @export
 */
export const SEGMENT_BUILDER_FORM_SELECT_IDS = {
  attribute: `property` /* key used in the segmentation API */,
  comparison: `comparison`,
  count: `count`,
  days: `days`,
  description: `description`,
  id: `id`,
  name: `name`,
  ruleOperator: `rule-operator-ruleset`,
  rulesetOperator: `ruleset-operator`,
  value: `value`,
};

/**
 * The data ids used in the toast messages for the segment builder.
 * @export
 */
export const SEGMENT_BUILDER_DATA_IDS = {
  buttonAddRule: `Button: Add segment rule`,
  buttonAddRuleset: `Button: Add segment rule set`,
  buttonDeleteRule: `Button: Delete segment rule`,
  buttonDeleteRuleset: `Button: Delete segment rule set`,
  buttonSaveSegment: `Button: Save segment`,
  countValueInput: `Form field: Count value`,
  daysValueInput: `Form field: Days value`,
  segmentAttributeSelect: `Form field: Select attribute`,
  segmentComparisonSelect: `Form field: Select rule comparison`,
  segmentDetailsDescription: `Form field: Segment description`,
  segmentDetailsName: `Form field: Segment name`,
  segmentDetailsSection: `Form: Segment details section`,
  segmentRule: `Container: Segment individual rule`,
  segmentRuleOperator: `Form field: Select rule matching logic`,
  segmentRuleset: `Container: Segment rule set`,
  segmentRulesetOperator: `Form field: Select rule set matching logic`,
  segmentRulesSection: `Form: Segment rules section`,
  segmentValueInput: `Form field: Input value`,
  toastFailCreate: `Toast: Segment creation failed`,
  toastFailUpdate: `Toast: Segment update failed`,
  toastSuccessCreate: `Toast: Segment created`,
  toastSuccessUpdate: `Toast: Segment updated`,
};

/**
 * Default segment data in string form to avoid object reference when creating a new segment.
 * @export
 */
export const defaultSegmentDataFromAPI = JSON.stringify({
  code: '',
  conditions: {
    and: [],
  },
  description: '',
  name: '',
});

/**
 * A default rule row used in the SegmentRules component to create the SegmentRules data structure.
 * @export
 */
export const RULE_ROW = {
  comparison: '',
  id: '0',
  property: '',
  type: '',
  value: '',
};

/**
 * Initial ruleset row used in the SegmentRules component to create the SegmentRules data structure.
 * @export
 */
export const RULESET_ROW_INITIAL = {
  id: '0',
  operator: 'or',
  rules: [
    {
      comparison: '',
      id: '0',
      property: '',
      type: '',
      value: '',
    },
  ],
};

/**
 * A default ruleset row used in the SegmentRules component to create the SegmentRules data structure.
 * @export
 */
export const RULESET_ROW = {
  id: '1',
  operator: 'and',
  rules: [
    {
      comparison: '',
      id: '0',
      property: '',
      type: '',
      value: '',
    },
  ],
};

/**
 * The type mapping which sets what type value should be based off of its attribute.
 * @export
 */
export const TYPE_MAP = new Map<string, string>([
  ['firstName', 'string'],
  ['lastName', 'string'],
  ['middleName', 'string'],
  ['otherNames', 'string'],
  ['gender', 'string'],
  ['languageCodeMajor', 'string'],
  ['languageCodeMinor', 'string'],
  ['email', 'string'],
  ['verifiedEmail', 'string'],
  ['verifiedUsername', 'string'],
  ['referrer', 'string'],
]);
